"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../comps/reusables");
exports.Nav = props => {
    const { activeTab, emailTemplateId } = props;
    return (react_1.default.createElement(reusables_1.NavPills, { activeTab: activeTab, queryDetailLayout: true, center: true, tabs: [
            {
                className: 'btn-success text-white',
                id: 'new-version',
                name: 'New version',
                navItemClassName: 'mr-2',
                to: `/templates/${emailTemplateId}/new-version`,
            },
            {
                id: 'versions',
                name: 'Versions',
                to: `/templates/${emailTemplateId}`,
            },
            {
                id: 'production',
                name: 'Production',
                to: `/templates/${emailTemplateId}/production`,
            },
            {
                id: 'staging',
                name: 'Staging',
                to: `/templates/${emailTemplateId}/staging`,
            },
            {
                id: 'deployments',
                name: 'Deployments',
                to: `/templates/${emailTemplateId}/deployments`,
            },
            {
                id: 'settings',
                name: 'Settings',
                to: `/templates/${emailTemplateId}/settings`,
            },
        ] }));
};
//# sourceMappingURL=Nav.js.map